import escapeStringRegexp from '@/utils/escapeStringRegexp';
import { separateAndMinimize } from '@/utils/separate';
import { Fragment, useMemo } from 'react';

type Props = {
  content: string;
  sub: string;
};

export const SubtextEmphasizer = ({ content, sub }: Props) => {
  const [first, ...rest] = useMemo(
    () => separateAndMinimize(content, new RegExp(escapeStringRegexp(sub), 'gi')),
    [content, sub],
  );

  return (
    <span>
      {first}
      {rest.map((part, index) =>
        // biome-ignore lint/suspicious/noArrayIndexKey: we don't have any other plausible candidate, and using index is safe in this context
        part.length ? <Fragment key={index}>{index % 2 ? part : <b>{part}</b>}</Fragment> : null,
      )}
    </span>
  );
};
